'use strict';
import DataLayer from "./datalayer";

let State = {
    initialized: false,
    appVersion: "1.3",
    language: "",
    title: "",
    firstName: "",
    lastName: "",
    company: "",
    country: "",
    city: "",
    postalCode: "",
    street: "",
    email: "",
    email2: "",
    installations: [],
    distributor: "",
    otherDistributor: "",
    feedback: "",
    signature: "",
    voucherNumber: "",
    init() {
        if (this.initialized) return;
        this.reset();
        this.initialized = true;
    },
    save() {
        //save user data to local storage
        if (!localStorage) return;
        let tmp = { ...this };
        tmp.installations = [];
        tmp.distributor = "";
        tmp.otherDistributor = "";
        tmp.feedback = "";
        tmp.voucherNumber = "";
        console.log("Saving user info to local storage...");
        localStorage.setItem("ASSW", JSON.stringify(tmp));
    },
    reset() {
        this.load();
        this.installations = [];
        this.installations.push(DataLayer.newInstallation());
        this.distributor = "";
        this.otherDistributor = "";
        this.feedback = "";
        this.voucherNumber = "";
    },
    load() {
        //load user data from local storage
        if (!localStorage) return;
        let info = localStorage.getItem("ASSW");
        if (info) {
            let o = JSON.parse(info);
            if (o) {
                this.appVersion = "1.3";
                this.title = o.title;
                this.lastName = o.lastName;
                this.firstName = o.firstName;
                this.company = o.company;
                this.country =  o.country;
                this.city = o.city;
                this.postalCode = o.postalCode;
                this.street = o.street;
                this.email = o.email;
                this.email2 = o.email2 || "";
                this.phone = o.phone;
            }
        }
    }
};

export default State;